import { render } from "./Eis_Dashboard_total.vue?vue&type=template&id=530b3018&scoped=true"
import script from "./Eis_Dashboard_total.vue?vue&type=script&lang=js"
export * from "./Eis_Dashboard_total.vue?vue&type=script&lang=js"

import "./Eis_Dashboard_total.vue?vue&type=style&index=0&id=530b3018&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530b3018"]])

export default __exports__